export default __webpack_public_path__ + "static/media/toyota-buckle-up-mobile.c955d1d5.svg";